import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

import "react-dates/initialize";

import cookie from "react-cookies";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { connect } from "react-redux";
import { isIOS } from "react-device-detect";

import "bootstrap-daterangepicker/daterangepicker.css";

import { moment, formatTime } from "../common/common";
import { commonErr } from "../common/errors";
import { LoadingInline } from "../common/loading";
import { MessageBox } from "../common/messagebox";
import { stypes, wdType, ThemeMode, convertToHourText, getHCMCityCoordinates } from "../common/common";
import WdTypeInfoBox from "../common/wdtypeinfobox";
import DateBox from "../common/datebox";
import DateBoxWD from "../common/dateboxwd";
import { TimeSelect } from "../carsubscription/components/timeselect"
import { OptionalTime } from "../carsubscription/components/optionaltime"

import {
	parseAddressToLocationWithLatLng,
	calculateDistance,
	parseWdMinHour,
	checkWdMinHour,
	setCookiesRoutes,
	getCookiesRoutes,
	getDurationTime,
	getEndDatewd,
	WDCalendarTemplate,
	WDECalendarTemplate,
} from "../common/wdfunction";

import { setFilter } from "../../actions/carFindingAct";

import {
	IcCalendarSearch,
	IcLocationSearch,
	IcCarSD,
	IcWD,
	IcEndLocWD,
	IcStartLocWD,
	IcTime,
	IcCloseOrange,
	IcPlusCGreen,
	IcCompass,
	Vali,
	People,
	Cap,
	CarNotChecked,
	Map,
	Star,
	IcCS,
	IcQuestion,
} from "../common/svg";

import HereAutoComplete from "../common/hereautocomplete";
import SearchSuggest from "../common/searchsuggest";

import bg1 from "../../static/images/landingpage/background/bg-landingpage-1.png";
import bg2 from "../../static/images/landingpage/background/bg-landingpage-2.png";
import bg3 from "../../static/images/landingpage/background/bg-landingpage-3.png";
import bg4 from "../../static/images/landingpage/background/bg-landingpage-4.png";
import holiday from "../../static/images/landingpage/holiday-theme/holiday-item.svg"

const LIST_BG = [
	{
		id: 1,
		imgBg: bg1,
	},
	{
		id: 2,
		imgBg: bg2,
	},
	{
		id: 3,
		imgBg: bg3,
	},
	{
		id: 4,
		imgBg: bg4,
	},
];

const LIST_NUMBER = [
	{
		id: 1,
		icon: <Vali />,
		title: `100,000+`,
		desc: `Chuyến đi đầy cảm hứng Mioto đã đồng&nbsp;hành`,
	},
	{
		id: 2,
		icon: <People />,
		title: `50,000+`,
		desc: `Khách hàng đã trải nghiệm dịch&nbsp;vụ`,
	},
	{
		id: 3,
		icon: <Cap />,
		title: `5,000+`,
		desc: `Đối tác chủ xe trong cộng&nbsp;đồng Mioto`,
	},
	{
		id: 4,
		icon: <CarNotChecked />,
		title: `100+`,
		desc: `Dòng xe khác nhau đang cho&nbsp;thuê`,
	},
	{
		id: 5,
		icon: <Map />,
		title: `10+`,
		desc: `Thành phố Mioto đã có&nbsp;mặt`,
	},
	{
		id: 6,
		icon: <Star />,
		title: `4.95/5*`,
		desc: `Là số điểm nhận được từ >50,000 khách&nbsp;hàng`,
	},
];

const NumberItem = ({ item }) => {
	return (
		<div className="number-item">
			<div className="wrap-svg">{item.icon}</div>
			<div className="text">
				<h6>{item.title}</h6>
				<p dangerouslySetInnerHTML={{ __html: item.desc }} />
			</div>
		</div>
	);
};

const NumberSection = () => {
	return (
		<div className="number">
			<div className="container-number">
				{LIST_NUMBER.map((item) => (
					<NumberItem key={item.id} item={item} />
				))}
			</div>
			<Swiper
				className="swiper-number"
				slidesPerView={1}
				spaceBetween={12}
				modules={[Pagination, Autoplay]}
				pagination={{
					el: ".pagi-number",
					clickable: true,
					dynamicBullets: true,
				}}
				autoplay={{
					delay: 10000,
					disableOnInteraction: false,
				}}
				loop={true}
				breakpoints={{
					768: {
						slidesPerView: 2,
					},
				}}>
				{LIST_NUMBER.map((item) => (
					<SwiperSlide key={item.id}>
						<NumberItem item={item} />
					</SwiperSlide>
				))}
				<div className="swiper-pagination pagi-number" />
			</Swiper>
		</div>
	);
};

const bookingTimes = [];
for (var i = 0; i < 1440; i = i + 30) {
	const time = i;
	const hour = (time - (time % 60)) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;
	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
}

class Cover extends React.Component {
	constructor() {
		super();
		this.state = {
			// common
			err: commonErr.INNIT,
			errMsg: "",
			stype: stypes.SD,
			deliveryAirportId: 0,
			deliveryAirportWDId: 0,
			// sd
			startDate: moment().set({
				hour: 21,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			endDate: moment().add(1, "days").set({
				hour: 20,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),

			lat: getHCMCityCoordinates.lat,
			lng: getHCMCityCoordinates.lng,
			isOpenSearching: true,
			// wd
			startDatewd: moment().set({
				hour: 21,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			endDatewd: moment().add(1, "days").set({
				hour: 20,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),

			startDatecs: moment().add(3, 'days').set({
				hour: 0,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			endDatecs: moment(moment().add(3, 'days').valueOf()).add(1, 'months').set({
				hour: 0,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			isCityTourMode: true,
			wdOneWay: false,
			addressArray: ["", ""],
			locationArray: [undefined, undefined],
			wdDistance: 0,
			wdDistanceOW: 0,
			wdDistanceBackOW: 0,
			deliveryAddressChangedFlag: false,
			isIframe: false,
			isSelectHour: false,
			gmapLoaded: false,
			isOpenInsBox: false,
			count: 0,
			bgRandom: LIST_BG[Math.floor(Math.random() * LIST_BG.length)],
			isCalendar: false,
			isDateBox: false,
			timeCS: 1,
			isOptionalTime: false,
			isSelectTimeCS: false
		};

		this.wrapperSelect = React.createRef();
		this.wrapperCSSelect = React.createRef();
	}

	componentDidMount() {
		if (this.props.city) {
			const locCity = Buffer.from(`${this.props.city.lat.toString()}-${this.props.city.lon.toString()}`).toString(
				"base64"
			);

			this.setState({
				address: this.props.city.name,
				locCity: locCity,
			});
		} else {
			// sd
			const lat = +cookie.load("_mlat");
			const lng = +cookie.load("_mlng");

			this.setState({
				address: cookie.load("_maddr") || "Hồ Chí Minh",
				lat: lat || getHCMCityCoordinates.lat,
				lng: lng || getHCMCityCoordinates.lng,
			});
			this.props.onSearchParams(
				lat || getHCMCityCoordinates.lat, 
				lng || getHCMCityCoordinates.lng,
				undefined,
				undefined,
			)
		}

		if (this.props.topDests && this.props.topDests.length > 0) {
			if (this.props.topDests[0].city === "HoChiMinh") {
				let locDest = Buffer.from(`${this.props.topDests[0].loc.lat.toString()}-${this.props.topDests[0].loc.lon.toString()}`).toString(
					"base64"
				);
	
				this.setState({
					addressCS: this.props.topDests[0].name,
					locCS: locDest,
				});
			} else {
				let locDest = Buffer.from('21.0328720558344'-'105.80320780094131').toString(
					"base64"
				);
				this.setState({
					addressCS: "Hồ Chí Minh",
					locCS: locDest
				});
			}
		}

		if (
			cookie.load("_mstartts") < moment().add(1, "hours").valueOf() &&
			cookie.load("_mendts") < moment().add(1, "hours").valueOf()
		) {
			cookie.remove("_mstartts", { path: "/" });
			cookie.remove("_mendts", { path: "/" });
		}

		// wd
		if (
			cookie.load("_mstarttswd") < moment().add(1, "hours").valueOf() &&
			cookie.load("_mendtswd") < moment().add(1, "hours").valueOf()
		) {
			cookie.remove("_mstarttswd", { path: "/" });
			cookie.remove("_mendtswd", { path: "/" });
			cookie.remove("_mmintswd", { path: "/" });
		}

		if (!cookie.load("_mstarttswd") || !cookie.load("_mendtswd") || !cookie.load("_mmintswd")) {
			cookie.remove("_mstarttswd", { path: "/" });
			cookie.remove("_mendtswd", { path: "/" });
			cookie.remove("_mmintswd", { path: "/" });
		}

		if (this.props.appInit.err === commonErr.SUCCESS) {
			// Wait for redux init app fulfilled

			// sd
			const isTimeCookieValueValid =
				cookie.load("_mstartts") > moment().add(1, "hours").valueOf() &&
				cookie.load("_mendts") > moment().add(1, "hours").valueOf();
			const startTs = isTimeCookieValueValid ? cookie.load("_mstartts") * 1 : this.props.appInit.data.startTime;
			const endTs = isTimeCookieValueValid ? cookie.load("_mendts") * 1 : this.props.appInit.data.endTime;

			this.setState({
				startDate: moment(startTs),
				endDate: moment(endTs),
				startTime: moment(startTs).get("hour") * 60 + moment(startTs).get("minute"),
				endTime: moment(endTs).get("hour") * 60 + moment(endTs).get("minute"),
				minDate: this.props.appInit.data.startDate,
				maxDate: this.props.appInit.data.endDate,
			}); 
			if (!this.props.city) {
				this.props.onSearchParams(undefined, undefined, startTs, endTs);
			}

			// wd
			this.wdMinHour = parseWdMinHour(
				this.props.appInit.data.wdMinHourCT,
				this.props.appInit.data.wdMinHour,
				this.props.appInit.data.wdMinHourOW
			);

			let isTimeCookieValueValidwd =
				cookie.load("_mstarttswd") > moment().add(1, "hours").valueOf() &&
				cookie.load("_mendtswd") > moment().add(1, "hours").valueOf() &&
				cookie.load("_mmintswd");
			let startTswd;
			let endTswd;
			let selectHour = cookie.load("_mmintswd") * 1;
			let durationTimeArr = getDurationTime(true, this.props.appInit.data.wdMinHourCT, 0);

			if (isTimeCookieValueValidwd) {
				startTswd = moment(cookie.load("_mstarttswd") * 1);
				endTswd =
					cookie.load("_mmintswd") * 1 > 0 ? getEndDatewd(selectHour, startTswd) : moment(cookie.load("_mendtswd") * 1);
			} else {
				startTswd = moment(this.props.appInit.data.wdStartTime);
				endTswd = getEndDatewd(durationTimeArr[1], startTswd);
				selectHour = durationTimeArr[1];
			}

			this.setState({
				startDatewd: startTswd,
				endDatewd: endTswd,
				startTimewd: startTswd.get("hour") * 60 + startTswd.get("minute"),
				endTimewd: endTswd.get("hour") * 60 + endTswd.get("minute"),
				durationTimeArr: durationTimeArr,
				selectHour: selectHour,
			});

			// wd

			if (this.props.city) {
				parseAddressToLocationWithLatLng(this.props.city.name, this.props.city.lat, this.props.city.lon, (location) => {
					const isCityTourMode = true;
					const wdOneWay = false;
					const addressArray = [this.props.city.name, ""];
					const locationArray = [location, undefined];

					this.setState({
						isCityTourMode,
						wdOneWay,
						addressArray,
						locationArray,
						wdDistance: 0,
					});
				});
			}
			const cRoutes = getCookiesRoutes();

			if (cRoutes && !this.props.city) {
				const {
					isCityTourMode,
					wdOneWay,
					addressArray,
					locationArray,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
					deliveryAddressChangedFlag,
				} = cRoutes;
				const wdMinHour = isCityTourMode
					? this.props.appInit.data.wdMinHourCT
					: wdOneWay
					? this.props.appInit.data.wdMinHourOW
					: this.props.appInit.data.wdMinHour;

				durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, wdDistance);
				selectHour = selectHour !== durationTimeArr[1] ? selectHour : durationTimeArr[1];
				endTswd = selectHour > 0 ? getEndDatewd(selectHour, startTswd) : moment(cookie.load("_mendtswd") * 1);

				if (addressArray.length === 1) {
					addressArray.push("");
					locationArray.push(undefined);
				}

				this.setState({
					isCityTourMode,
					wdOneWay,
					addressArray,
					locationArray,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
					deliveryAddressChangedFlag,
					durationTimeArr,
					selectHour,
					endDatewd: endTswd,
					endTimewd: endTswd.get("hour") * 60 + endTswd.get("minute"),
				});
			}
		}

		

		if (this.props.iframe != null && this.props.iframe) {
			this.setState({
				isIframe: true,
			});
		}

		const airportCookie = cookie.load("_mairport")?.split("|");
		if (airportCookie && airportCookie[0] === cookie.load("_maddr")) {
			this.setState({
				deliveryAirportId: airportCookie[1],
			});
		}
		const wdRoutes = getCookiesRoutes();
		const airportWDCookie = cookie.load("_mairportWD")?.split("|");
		if (wdRoutes && airportWDCookie && airportWDCookie[0] === wdRoutes.addressArray[0]) {
			this.setState({
				deliveryAirportWDId: airportWDCookie[1],
			});
		}
		document.addEventListener("click", this.handleClick);
		window.addEventListener("resize", this.updateDimensions);
	}

	// Only use purpose for init value start/end date,time by use appInit of redux value when invalid cookie
	componentDidUpdate(props, state) {
		if (props.appInit.err !== this.props.appInit.err) {
			// Wait for redux init app fulfilled

			if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) {
				// sd
				const isTimeCookieValueValid =
					cookie.load("_mstartts") > moment().add(1, "hours").valueOf() &&
					cookie.load("_mendts") > moment().add(1, "hours").valueOf();
				const startTs = isTimeCookieValueValid ? cookie.load("_mstartts") * 1 : this.props.appInit.data.startTime;
				const endTs = isTimeCookieValueValid ? cookie.load("_mendts") * 1 : this.props.appInit.data.endTime;

				this.setState({
					startDate: moment(startTs),
					endDate: moment(endTs),
					startTime: moment(startTs).get("hour") * 60 + moment(startTs).get("minute"),
					endTime: moment(endTs).get("hour") * 60 + moment(endTs).get("minute"),
					minDate: this.props.appInit.data.startDate,
					maxDate: this.props.appInit.data.endDate,
				});
				if (!this.props.city) {
					this.props.onSearchParams(undefined, undefined, startTs, endTs);
				}

				// wd
				this.wdMinHour = parseWdMinHour(
					this.props.appInit.data.wdMinHourCT,
					this.props.appInit.data.wdMinHour,
					this.props.appInit.data.wdMinHourOW
				);

				let isTimeCookieValueValidwd =
					cookie.load("_mstarttswd") > moment().add(1, "hours").valueOf() &&
					cookie.load("_mendtswd") > moment().add(1, "hours").valueOf() &&
					cookie.load("_mmintswd");
				let startTswd;
				let endTswd;
				let selectHour = cookie.load("_mmintswd") * 1;
				let durationTimeArr = getDurationTime(true, this.props.appInit.data.wdMinHourCT, 0);

				if (isTimeCookieValueValidwd) {
					startTswd = moment(cookie.load("_mstarttswd") * 1);
					endTswd =
						cookie.load("_mmintswd") * 1 > 0
							? getEndDatewd(selectHour, startTswd)
							: moment(cookie.load("_mendtswd") * 1);
				} else {
					startTswd = moment(this.props.appInit.data.wdStartTime);
					endTswd = getEndDatewd(durationTimeArr[1], startTswd);
					selectHour = durationTimeArr[1];
				}

				this.setState({
					startDatewd: startTswd,
					endDatewd: endTswd,
					startTimewd: startTswd.get("hour") * 60 + startTswd.get("minute"),
					endTimewd: endTswd.get("hour") * 60 + endTswd.get("minute"),
					durationTimeArr: durationTimeArr,
					selectHour: selectHour,
				});
				// wd
				const cRoutes = getCookiesRoutes();

				if (cRoutes) {
					const {
						isCityTourMode,
						wdOneWay,
						addressArray,
						locationArray,
						wdDistance,
						wdDistanceOW,
						wdDistanceBackOW,
						deliveryAddressChangedFlag,
					} = cRoutes;
					const wdMinHour = isCityTourMode
						? this.props.appInit.data.wdMinHourCT
						: wdOneWay
						? this.props.appInit.data.wdMinHourOW
						: this.props.appInit.data.wdMinHour;

					durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, wdDistance);
					selectHour = selectHour !== durationTimeArr[1] ? selectHour : durationTimeArr[1];
					endTswd = selectHour > 0 ? getEndDatewd(selectHour, startTswd) : moment(cookie.load("_mendtswd") * 1);

					if (addressArray.length === 1) {
						addressArray.push("");
						locationArray.push(undefined);
					}
					this.setState({
						isCityTourMode,
						wdOneWay,
						addressArray,
						locationArray,
						wdDistance,
						wdDistanceOW,
						wdDistanceBackOW,
						deliveryAddressChangedFlag,
						durationTimeArr,
						selectHour,
						endDatewd: endTswd,
						endTimewd: endTswd.get("hour") * 60 + endTswd.get("minute"),
					});
				}
			}
		}
	}

	updateDimensions = () => {
		if (window.innerWidth <= 991) {
			this.setState({
				isMCalendar: true,
			});
		} else {
			this.setState({
				isMCalendar: false,
			});
		}
	};

	UNSAFE_componentWillUnmount() {
		// important
		document.removeEventListener("click", this.handleClick);
	}

	handleClick = (event) => {
		const { stype } = this.state;

		if (stype === stypes.WD) {
			const { target } = event;
			if (target !== null && this.wrapperSelect.current !== null && !this.wrapperSelect.current.contains(target)) {
				const { isSelectHour } = this.state;
				if (isSelectHour) {
					this.setState({
						isSelectHour: false,
					});
				}
			}
		}

		if (stype === stypes.CS) {
			const { target } = event;

			if (target !== null && this.wrapperCSSelect.current !== null && !this.wrapperCSSelect.current.contains(target)) {
				const { isSelectTimeCS } = this.state;
				if (isSelectTimeCS) {
					this.setState({
						isSelectTimeCS: false,
					});
				}
			}
		}
	};

	setSTypes = (stype) => {
		this.setState({
			stype,
		});
		this.props.onSType(stype);
	};

	onStartDateChange = (event, picker) => {
		let { endDate } = this.state;
		const { startDate } = picker; // New picker value, only use (date, month, year)

		startDate.set({
			hour: this.state.startDate.get("hour"),
			minute: this.state.startDate.get("minute"),
			second: 0,
			milliseconds: 0,
		});

		// Specical case, inscrease endDate + 1 days, hold time
		if (startDate >= endDate) {
			endDate = startDate
				.clone()
				.add(1, "days")
				.set({
					hour: endDate.get("hour"),
					minute: endDate.get("minute"),
					second: 0,
					milliseconds: 0,
				});
		}
		cookie.save("_mstartts", startDate.valueOf(), { path: "/" });
		cookie.save("_mendts", endDate.valueOf(), { path: "/" });
		this.toggleSearching();
		this.setState({
			startDate: startDate,
			endDate: endDate,
		});
		if (!this.props.city) {
			this.props.onSearchParams(undefined, undefined, startDate.valueOf(), endDate.valueOf());
		}
		this.toggleSearching();
	};

	onDateRangeChange = (picker) => {
		let { endDate, startDate } = picker; // New picker value, only use (date, month, year)
		let { startTime, endTime } = this.state;
	
		if (startDate && endDate) {

			const cstartTime = Number(startTime);
			const cendTime = Number(endTime);

			startDate = moment(picker.startDate).set({
				hour: (cstartTime - cstartTime % 60) / 60,
				minute: cstartTime % 60,
				second: 0
			});

			endDate = moment(picker.endDate).set({
				hour: (cendTime - cendTime % 60) / 60,
				minute: cendTime % 60,
				second: 0
			});

		
			const hour = (cendTime - cstartTime)/60;

			const isSameDay = endDate.format('DD/MM/YYYY') == startDate.format('DD/MM/YYYY');

			if (isSameDay && (0 <= hour && hour < 2)) {
				return;
			} else if (startDate.valueOf() > endDate.valueOf()) {
				return;
			}
		
			cookie.save("_mstartts", startDate.valueOf(), { path: "/" });
			cookie.save("_mendts", endDate.valueOf(), { path: "/" });


	
			this.setState({
				startDate: startDate,
				endDate: endDate,
			});
			if (!this.props.city) {
				this.props.onSearchParams(undefined, undefined, startDate.valueOf(), endDate.valueOf());
			}
		}
		
	};

	toggleSearching = () => {
		this.setState({
			isOpenSearching: !this.state.isOpenSearching,
		});
	};

	onStartTimeChange = (time) => {

		const { endDate, endTime } = this.state;
		// const hour = (time - (time % 60)) / 60;
		// const minute = time % 60;
		let startDate = this.state.startDate;
		// Assign with new picker value (hour, minute)
		startDate = moment(this.state.startDate).set({
			hour: (time - time % 60) / 60,
			minute: time % 60,
			second: 0
		});

		if (startDate && endDate) {
			const hour = Number((endTime - time)/60)
			const isSameDay = endDate.format('DD/MM/YYYY') === startDate.format('DD/MM/YYYY')

			if (isSameDay && 0 <= hour && hour < 2) {
				return;
			} else if (startDate.valueOf() > endDate.valueOf()) {
				return;
			}

			
			cookie.save("_mstartts", startDate.valueOf(), { path: "/" });
			this.setState({
				startDate,
				startTime: time,
			});
			if (!this.props.city) {
				this.props.onSearchParams(undefined, undefined, startDate.valueOf(), undefined);
			}
		}

	
	};

	onEndTimeChange = (time) => {
		// const time = event.target.value;
		const { startDate, startTime } = this.state;
		// const hour = (time - (time % 60)) / 60;
		// const minute = time % 60;
		let endDate = this.state.endDate;

		endDate = moment(this.state.endDate).set({
			hour: (time - time % 60) / 60,
			minute: time % 60,
			second: 0
		});

		// Specical case, not apply change
		// if (this.state.startDate >= endDate) {
		// 	this.setState({
		// 		err: commonErr.FAIL,
		// 		errMsg: "Thời gian thuê xe không hợp lệ.",
		// 	});
		// 	return;
		// }

		if (startDate && endDate) {
			const hour = Number((time - startTime)/60)
			const isSameDay = endDate.format('DD/MM/YYYY') === startDate.format('DD/MM/YYYY');
	

			if (isSameDay && (0 <= hour && hour < 2)) {
				return;
			} else if (startDate.valueOf() > endDate.valueOf()) {
				return;
			}

			cookie.save("_mendts", endDate.valueOf(), { path: "/" });
			this.setState({
				endDate,
				endTime: time,
			});
			if (!this.props.city) {
				this.props.onSearchParams(undefined, undefined, undefined, endDate.valueOf());
			}
		}
	
		
	};

	findCar = (e) => {
		const { address, isIframe, startDate, endDate, locCity, deliveryAirportId} = this.state;

		if (!address || address === "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng nhập địa chỉ để tìm kiếm.",
			});
			e.preventDefault();
			return false;
		}

		if (isIframe) {
			this.props.trackToGAAtFindCar();
		}

		if (this.props.city) {
			window.history.pushState({ prevUrl: window.location.href }, null, `/find/filter?startDate=${startDate.valueOf()}&endDate=${endDate ? endDate.valueOf() : null}&address=${address}&loc=${locCity}`)
			window.location.reload()
		} else {
			window.history.pushState({ prevUrl: window.location.href }, null, `/find/filter?startDate=${startDate.valueOf()}&endDate=${endDate ? endDate.valueOf(): null}&address=${address}${deliveryAirportId !== 0 ? `&deliveryId=${deliveryAirportId}&isAirDelivery=true` : ""}`)
			window.location.reload()
		}
	};

	onAddressFocus = (e) => {
		this.setState({
			address: "",
		});
	};

	onAddressChange = (address) => {
		this.setState({
			address: address,
		});
	};

	onSelectFromAddr = (address) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			this.setState({
				err: commonErr.SUCCESS,
				address: address.address,
				lat: +address.lat,
				lng: +address.lng,
			});
			if (!this.props.city) {
				this.props.onSearchParams(
					+address.lat,
					+address.lng,
					undefined,
					undefined,
				)
			}
		}

		const filter = {
			...this.props.carFinding.filter,
			address: address.address,
			lat: address.lat,
			lng: address.lng,
		};
		this.setFilter(filter);
	};

	setFilter = (filter) => {
		this.props.dispatch(setFilter(filter));
	};

	hideMessageBox = () => {
		this.setState({
			errMsg: "",
		});
	};

	showWdTypeInfoBox = (wdType) => {
		this.setState({
			isShowWdTypeInfoBox: true,
			wdType,
		});
	};

	hideWdTypeInfoBox = () => {
		this.setState({
			isShowWdTypeInfoBox: false,
		});
	};

	onStartDateChangewd = (startDatewd) => {
		let { wdDistance, isCityTourMode, wdOneWay, endDatewd, selectHour } = this.state;
		// const startDatewd = picker.startDate; // New picker value, only use (date, month, year)

		// startDatewd.set({
		// 	hour: startDatewd.get("hour"),
		// 	minute: startDatewd.get("minute"),
		// 	second: 0,
		// 	milliseconds: 0,
		// });
		// Specical case, inscrease endDatewd + 1 days, hold time
		if (startDatewd >= endDatewd) {
			endDatewd = startDatewd
				.clone()
				.add(1, "days")
				.set({
					hour: endDatewd.get("hour"),
					minute: endDatewd.get("minute"),
					second: 0,
					milliseconds: 0,
				});
		}

		if (selectHour > 0) {
			endDatewd = getEndDatewd(selectHour, startDatewd);
		}

		cookie.save("_mstarttswd", startDatewd.valueOf(), { path: "/" });
		cookie.save("_mendtswd", endDatewd.valueOf(), { path: "/" });
		this.toggleSearching();
		this.setState({
			startDatewd: startDatewd,
			endDatewd: endDatewd,
			// wdMinHourDetected: checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour)
		});
		this.toggleSearching();
	};

	onDateRangeChangewd = (endDate) => {
		let { wdDistance, isCityTourMode, wdOneWay, startDatewd } = this.state;
		let endDatewd = endDate; // New picker value, only use (date, month, year)ç

		endDatewd.set({
			hour: endDatewd.get("hour"),
			minute: endDatewd.get("minute"),
			second: 0,
			milliseconds: 0,
		});

		// Specical case, not apply change
		if (this.state.startDatewd >= endDatewd) {
			return;
		}

		cookie.save("_mendtswd", endDatewd.valueOf(), { path: "/" });
		this.toggleSearching();
		this.setState({
			endDatewd: endDatewd,
			selectHour: 0,
			wdMinHourDetected: checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour),
		});
		this.toggleSearching();
	};

	onStartTimeChangewd = (time) => {
		const { selectHour } = this.state;
		// const time = event.target.value;
		const hour = (time - (time % 60)) / 60;
		const minute = time % 60;
		const startDatewd = this.state.startDatewd.clone();

		startDatewd.set({
			hour,
			minute,
			second: 0,
			milliseconds: 0,
		});

		if (selectHour > 0) {
			let endDatewd = getEndDatewd(selectHour, startDatewd);

			cookie.save("_mendtswd", endDatewd.valueOf(), { path: "/" });

			this.setState({
				endDatewd: endDatewd,
				endTimewd: endDatewd.get("hour") * 60 + endDatewd.get("minute"),
			});
		} else {
			// Specical case, not apply change
			if (startDatewd >= this.state.endDatewd) {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Thời gian thuê xe không hợp lệ.",
				});
				return;
			}
		}

		cookie.save("_mstarttswd", startDatewd.valueOf(), { path: "/" });

		this.setState({
			startDatewd,
			startTimewd: time,
		});
	};

	onEndTimeChangewd = (time) => {
		let { wdDistance, startDatewd, isCityTourMode, wdOneWay } = this.state;

		// const time = event.target.value;
		let hour = (time - (time % 60)) / 60;
		let minute = time % 60;
		const endDatewd = this.state.endDatewd.clone();

		endDatewd.set({
			hour,
			minute,
			second: 0,
			milliseconds: 0,
		});

		// Specical case, not apply change
		if (this.state.startDatewd >= endDatewd) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Thời gian thuê xe không hợp lệ.",
			});
			return;
		}
		cookie.save("_mendtswd", endDatewd.valueOf(), { path: "/" });
		this.setState({
			endDatewd,
			endTimewd: time,
			selectHour: 0,
			wdMinHourDetected: checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour),
		});
	};

	findCarwd = (e) => {
		const { addressArray, isCityTourMode, wdMinHourDetected, startDatewd, endDatewd, isIframe, wdOneWay, selectHour, deliveryAirportWDId } = this.state;

		if (addressArray[0] === "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng nhập địa chỉ để tìm kiếm.",
			});
			e.preventDefault();
			return false;
		} else if (addressArray.includes("") && !isCityTourMode) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng nhập địa chỉ còn trống.",
			});
			e.preventDefault();
			return false;
		} else if (wdMinHourDetected) {
			this.setState({
				err: commonErr.FAIL,
				errMsg:
					"Vui lòng chọn lại thời gian. Thời gian thuê tối thiểu cho lộ trình trên là " + wdMinHourDetected + " tiếng.",
			});
			e.preventDefault();
			return false;
		} else {
			// e.preventDefault();
			const { wdOneWay, wdDistance, wdDistanceOW, wdDistanceBackOW, locationArray, deliveryAddressChangedFlag } =
				this.state;

			// If is city tour mode and includes blank address
			if (addressArray.includes("")) {
				// format wdLocations
				const wdLocations = `${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString(
					"base64"
				)}`;
				// save cooke
				setCookiesRoutes({
					isCityTourMode,
					wdOneWay,
					wdDistance: 0,
					wdDistanceOW: 0,
					wdDistanceBackOW: 0,
					wdLocations,
					deliveryAddressChangedFlag,
				});
			} else {
				// format wdLocations
				let wdLocations = "";
				for (let i = 0; i < addressArray.length; i++) {
					wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
						"base64"
					)}${i !== addressArray.length - 1 ? "," : ""}`;
				}
				// save cooke
				setCookiesRoutes({
					isCityTourMode,
					wdOneWay,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
					wdLocations,
					deliveryAddressChangedFlag,
				});
			}
		}

		if (startDatewd < moment().add(1, "hours").valueOf() || endDatewd < moment().add(1, "hours").valueOf()) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Thời gian tìm kiếm không hợp lệ.",
			});
			e.preventDefault();
			return false;
		}

		if (isIframe) {
			this.props.trackToGAAtFindCar();
		}

	
		e.preventDefault();	
		window.history.pushState({ prevUrl: window.location.href }, null, `/withdriver/find/filter?startDate=${startDatewd.valueOf()}&endDate=${endDatewd.valueOf()}&address=${addressArray.includes("") ? addressArray[0] : addressArray.join(";")}&isCityTourMode=${isCityTourMode}&isOneWay=${wdOneWay}&selectHour=${selectHour}${deliveryAirportWDId !== 0 ? `&deliveryId=${deliveryAirportWDId}&isAirDelivery=true` : ""}`)
		window.location.reload()
		
	};

	onAddressFocuswd = (e, i) => {
		const addressArray = [...this.state.addressArray];
		addressArray[i] = "";
		const locationArray = [...this.state.locationArray];
		locationArray[i] = undefined;

		this.setState({
			addressArray,
			locationArray,
			wdMinHourDetected: undefined,
		});
	};

	onAddressChangewd = (address, i) => {
		let addressArray = [...this.state.addressArray];
		addressArray[i] = address;

		this.setState({
			addressArray,
		});
	};

	onSelectAddresswd = (address, i) => {
		const { isCityTourMode, wdOneWay, selectHour, startDatewd, endDatewd } = this.state;
		const wdMinHour = isCityTourMode
			? this.props.appInit.data.wdMinHourCT
			: wdOneWay
			? this.props.appInit.data.wdMinHourOW
			: this.props.appInit.data.wdMinHour;

		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			// success
			let addressArray = [...this.state.addressArray];
			addressArray[i] = address.address;
			parseAddressToLocationWithLatLng(address.address, address.lat, address.lng, (location) => {
				let locationArray = [...this.state.locationArray];
				locationArray[i] = location;

				// if city tour
				if (isCityTourMode) {
					this.setState({
						err: commonErr.SUCCESS,
						addressArray,
						locationArray,
						// wdMinHourDetected: checkWdMinHour(isCityTourMode, wdOneWay, 0, startDatewd, endDatewd, this.wdMinHour),
						deliveryAddressChangedFlag: true,
					});

					return;
				}
				// if across province
				else {
					if (addressArray.includes("")) {
						// only set state
						this.setState({
							err: commonErr.SUCCESS,
							addressArray,
							locationArray,
						});
					} else {
						// compute distance
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
							let wdMinHourDetected = checkWdMinHour(
								false,
								wdOneWay,
								wdDistance,
								startDatewd,
								endDatewd,
								this.wdMinHour
							);

							if (wdMinHourDetected) {
								this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);
							}

							this.setState({
								err: commonErr.SUCCESS,
								addressArray,
								locationArray,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								// wdMinHourDetected: checkWdMinHour(false, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour)
							});
						});
					}
				}
			});
		}
	};

	onTripModeChange = (value, wdOneWay) => {

		const { addressArray, locationArray, wdDistance, startDatewd, endDatewd, deliveryAddressChangedFlag } =
			this.state;
		const wdMinHour = value
			? this.props.appInit.data.wdMinHourCT
			: wdOneWay
			? this.props.appInit.data.wdMinHourOW
			: this.props.appInit.data.wdMinHour;

		if (value === false && addressArray.length === 1) return;
		if (value === true) {
			//switch to city tour

			this.getDurationTime(value, wdMinHour, 0);

			this.setState({
				isCityTourMode: value,
				wdOneWay: wdOneWay
				// wdMinHourDetected:  checkWdMinHour(value, wdOneWay, 0, startDatewd, endDatewd, this.wdMinHour),
			});
		} else {
			//switch to across province
			if (addressArray.includes("")) {
				if (wdOneWay) {
					this.setState({
						wdOneWay: true,
						isCityTourMode: value,
					});
				} else {
					this.getDurationTime(value, wdMinHour, 0);

					this.setState({
						isCityTourMode: value,
						wdOneWay: false
					});
				}
			} else {
				if (deliveryAddressChangedFlag) {
					if (wdOneWay) {
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {

						this.getDurationTime(false, wdMinHour, wdDistanceOW);

						this.setState({
							wdOneWay,
							wdDistance,
							isCityTourMode: value,
							// wdMinHourDetected: checkWdMinHour(false, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour)
						});

						})

					} else {

					calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
						// let minHour = checkWdMinHour(value, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour)

						this.getDurationTime(value, wdMinHour, wdDistance);

						this.setState({
							isCityTourMode: value,
							wdDistance,
							wdDistanceOW,
							wdDistanceBackOW,
							wdOneWay: false,
							// wdMinHourDetected: checkWdMinHour(value, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour),
							deliveryAddressChangedFlag: false,
						});
					});
					}
				} else {
					this.getDurationTime(value, wdMinHour, wdDistance);

					this.setState({
						isCityTourMode: value,
						// wdMinHourDetected: checkWdMinHour(value, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour),
						wdOneWay: wdOneWay
					});
				}
			}
		}
	};

	onOneWayChange = () => {
		const wdOneWay = !this.state.wdOneWay;
		const wdMinHour = wdOneWay ? this.props.appInit.data.wdMinHourOW : this.props.appInit.data.wdMinHour;

		if (this.state.addressArray.includes("")) {
			this.setState({
				wdOneWay,
			});
		} else {
			const { wdDistanceOW, wdDistanceBackOW, startDatewd, endDatewd } = this.state;
			const wdDistance = wdOneWay ? wdDistanceOW : wdDistanceOW + wdDistanceBackOW;

			this.getDurationTime(false, wdMinHour, wdDistance);

			this.setState({
				wdOneWay,
				wdDistance,
				// wdMinHourDetected: checkWdMinHour(false, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour)
			});
		}
	};

	onRemoveStopPoint = (i) => {
		const { startDatewd, endDatewd, isCityTourMode, wdOneWay } = this.state;
		const wdMinHour = isCityTourMode
			? this.props.appInit.data.wdMinHourCT
			: wdOneWay
			? this.props.appInit.data.wdMinHourOW
			: this.props.appInit.data.wdMinHour;

		const addressArray = [...this.state.addressArray];
		addressArray.splice(i, 1);
		const locationArray = [...this.state.locationArray];
		locationArray.splice(i, 1);

		if (addressArray.length === 1) {
			this.getDurationTime(isCityTourMode, wdMinHour, 0);

			if (addressArray[0] === "") {
				// not validate hour
				this.setState({
					isCityTourMode: true,
					addressArray,
					locationArray,
					// wdMinHourDetected: undefined
				});
			} else {
				// validate hour

				this.setState({
					isCityTourMode: true,
					addressArray,
					locationArray,
					// wdMinHourDetected: checkWdMinHour(isCityTourMode, wdOneWay, 0, startDatewd, endDatewd, this.wdMinHour)
				});
			}
		} else {
			// >=2 address
			if (addressArray.includes("")) {
				this.setState({
					addressArray,
					locationArray,
				});
			} else {
				calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
					let wdMinHourDetected = checkWdMinHour(
						isCityTourMode,
						wdOneWay,
						wdDistance,
						startDatewd,
						endDatewd,
						this.wdMinHour
					);

					if (wdMinHourDetected) {
						this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);
					}

					this.setState({
						addressArray,
						locationArray,
						wdDistance,
						wdDistanceOW,
						wdDistanceBackOW,
						// wdMinHourDetected: checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDatewd, endDatewd, this.wdMinHour)
					});
				});
			}
		}
	};

	onAddStopPoint = () => {
		const { addressArray, locationArray, isCityTourMode } = this.state;
		if (addressArray.length >= 5) return;
		if (isCityTourMode) {
			this.setState({
				isCityTourMode: false,
				addressArray: [addressArray[0], ""],
				locationArray: [locationArray[0], undefined],
				deliveryAddressChangedFlag: false,
			});
		} else {
			this.setState({
				addressArray: [...addressArray, ""],
				locationArray: [...locationArray, undefined],
			});
		}
	};

	getDurationTime = (wdMode, wdMinHour, distance) => {
		const startDatewd = this.state.startDatewd.clone();
		let durationTimeArr = getDurationTime(wdMode, wdMinHour, distance);
		let endDatewd = getEndDatewd(durationTimeArr[1], startDatewd);

		cookie.save("_mendtswd", endDatewd.valueOf(), { path: "/" });

		this.setState({
			endDatewd,
			endTimewd: endDatewd.get("hour") * 60 + endDatewd.get("minute"),
			durationTimeArr,
			selectHour: durationTimeArr[1],
		});
	};

	toggleDurationTimeBox = () => {
		const { isSelectHour } = this.state;

		this.setState({
			isSelectHour: !isSelectHour,
		});
	};

	toggleSelectTimeCS = () => {
		const { isSelectTimeCS } = this.state;

		this.setState({
			isSelectTimeCS: !isSelectTimeCS,
		});
	};


	handleClickSameValue = (time) => {
		// const { selectHour } = this.state;
		// if (time === selectHour) {
		// 	this.setState({
		// 		isSelectHour: false
		// 	})
		// }
	};

	onSelectHourChange = (event) => {
		let { endDatewd } = this.state;
		const { name } = event.target;
		const selectHour = Number(event.target.value);
		const startDatewd = this.state.startDatewd.clone();

		if (selectHour > 0) {
			endDatewd = getEndDatewd(selectHour, startDatewd);

			this.setState({
				wdMinHourDetected: undefined,
				endDatewd: endDatewd,
				endTimewd: endDatewd.get("hour") * 60 + endDatewd.get("minute"),
			});
		}

		this.setState({
			[name]: selectHour,
			isSelectHour: false,
		});

		cookie.save("_mendtswd", endDatewd.valueOf(), { path: "/" });
		cookie.save("_mmintswd", selectHour, { path: "/" });
	};

	showInsBox = () => {
		this.setState({
			isOpenInsBox: true,
		});
	};

	hideInsBox = () => {
		this.setState({
			isOpenInsBox: false,
		});
	};

	getDeliveryAirportId = (id) => {
		this.setState({
			deliveryAirportId: id,
		});
	};

	getDeliveryAirportWDId = (id) => {
		this.setState({
			deliveryAirportWDId: id,
		});
	};

	openCalendar = () => {
		this.setState({
			isCalendar: true,
		});
	};

	hideCalendar = () => {
		this.setState({
			isCalendar: false,
		});
	};

	openWDCalendar = () => {
		this.setState({
			isDateBox: true,
		});
	};

	closeWDCalendar = () => {
		this.setState({
			isDateBox: false,
		});
	};

	onSelectTimeCSChange = (e) => {
		let { endDatecs, startDatecs } = this.state;
		const time = e.target.value; 

		if (time > 0) {
			endDatecs = moment(startDatecs).add(time, 'months')

			this.setState({
				timeCS: time,
				endDatecs
			})
		} else {
			this.showOptionalTime()
			this.setState({
				timeCS: time
			})
		}
	}

	showOptionalTime = () => {
		this.setState({
			isOptionalTime: true
		})
	}

	hideOptionalTime = () => {
		this.setState({
			isOptionalTime: false
		})
	}

	render() {
		const {
			err,
			errMsg,
			isOpenSearching,
			isHighlight,
			address,
			startDate,
			endDate,
			startTime,
			endTime,
			addressArray,
			startDatewd,
			endDatewd,
			startTimewd,
			endTimewd,
			startDatecs,
			endDatecs,
			isCityTourMode,
			wdMinHourDetected,
			wdDistance,
			wdOneWay,
			isIframe,
			durationTimeArr,
			selectHour,
			isSelectHour,
			gmapLoaded,
			isOpenInsBox,
			latC,
			lngC,
			bgRandom,
			deliveryAirportId,
			deliveryAirportWDId,
			isDateBox,
			addressCS,
			locCS,
			timeCS,
			isOptionalTime,
			isSelectTimeCS
		} = this.state;
		const { theme, stype, city, isMCalendar } = this.props;
	
		var content;

		if (stype === stypes.SD) {
			content = (
				<>
				<div className="search-form sd">
					<div className="search-form__item address">
						<div className="title">
							<div className="wrap-svg">
								<IcLocationSearch />
							</div>
							<p>Địa điểm</p>
						</div>

						<div className="choose">
							<div className="choose-item has-arrow" htmlFor={1}>
								<SearchSuggest
									hidden={false}
									focusAddress={true}
									sd={true}
									getDeliveryAirportId={this.getDeliveryAirportId}
									inputProps={{
										value: address,
										onChange: this.onAddressChange,
										placeholder: address && address != "" ? address : "Nhập địa điểm thuê xe",
									}}
									onSelect={(address) => this.onSelectFromAddr(address)}
								/>
							</div>
						</div>
					</div>
					<div className="line line-address-time"></div>

					<div className="search-form__item" onClick={this.openCalendar}>
						<div className="title">
							<div className="wrap-svg">
								<IcCalendarSearch />
							</div>
							<p>Thời gian thuê</p>
						</div>
						<div className="choose">
							<label className="choose-item has-arrow">
								<span className="value">
									{startTime >= 0 ? formatTime(startTime) : "Chọn giờ"},{" "}
									{startDate ? startDate.format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")} -{" "}
									{endTime >= 0 ? formatTime(endTime) : "Chọn giờ"},{" "}
									{endDate ? endDate.format("DD/MM/YYYY") : moment().add(1, "days").format("DD/MM/YYYY")}
								</span>
							</label>
							{/* <div className="line" /> */}
							{/* <label className="choose-item has-arrow">
									<span className="value">{startDate ? startDate.format("HH:mm") : ""}</span>
								</label> */}
						</div>
					</div>
					
					{this.state.isCalendar && (
						<DateBox
							startDate={startDate}
							endDate={endDate}
							startTime={startTime}
							endTime={endTime}
							finding={false}
							onStartTimeChange={this.onStartTimeChange}
							onEndTimeChange={this.onEndTimeChange}
							onDatesChange={this.onDateRangeChange}
							show={this.state.isCalendar}
							isMCalendar={isMCalendar}
							hideModal={this.hideCalendar}
						/>
					)}

					{city ? (
						// <Link
						// 	className="btn btn-primary"
						// 	target={`${isIframe ? "_blank" : ""}`}
						// 	onClick={() => { 
						// 		this.findCar();
						// 	}}
						// 	to={{
						// 		pathname: `/find/filter`,
						// 		search: `startDate=${startDate.valueOf()}&endDate=${
						// 			endDate ? endDate.valueOf() : null
						// 		}&address=${address}&loc=${this.state.locCity}`,
						// 	}}>
						
							<a className="btn btn-primary" target={`${isIframe ? "_blank" : ""}`} onClick={this.findCar} >
						
								Tìm Xe
							</a>
					
					) : (
						// <Link
						// 	className="btn btn-primary"
						// 	onClick={this.findCar}
						// 	to={{
						// 		pathname: `/find/filter`,
						// 		search: `startDate=${startDate.valueOf()}&endDate=${
						// 			endDate ? endDate.valueOf() : null
						// 		}&address=${address}${
						// 			deliveryAirportId !== 0 ? `&deliveryId=${deliveryAirportId}&isAirDelivery=true` : ""
						// 		}`,
						// 	}}>
						// 	Tìm Xe
						// </Link>
						<a className="btn btn-primary" target={`${isIframe ? "_blank" : ""}`} onClick={this.findCar} >
					
						Tìm Xe
						</a>
					)}

					<MessageBox show={errMsg !== ""} hideModal={this.hideMessageBox} message={errMsg} />
				</div>
				</>
			);
		} else if (stype === stypes.WD) {
			content = <>
				
					<h6 className="title-wd">Lộ trình</h6>
					<div className="wd-option-form">
						<div className="custom-radio">
							<input
								type="radio"
								id="city"
								name="trip_mode"
								checked={isCityTourMode && !wdOneWay}
								onChange={() => this.onTripModeChange(true, false)}
							/>
							<label htmlFor="city">Nội thành</label>
						</div>
						<div className="custom-radio">
							<input
								type="radio"
								id="province"
								name="trip_mode"
								checked={!isCityTourMode && !wdOneWay}
								onChange={() => this.onTripModeChange(false, false)}
							/>
							<label htmlFor="province">Liên tỉnh</label>
						</div>
						<div className="custom-radio">
							<input
								type="radio"
								id="province_oneWay"
								name="trip_mode"
								checked={!isCityTourMode && wdOneWay}
								onChange={() => this.onTripModeChange(false, true)}
							/>
							<label htmlFor="province_oneWay">Liên tỉnh (1 chiều)</label>
						</div>
					
					</div>

					{isCityTourMode ? (
						<>
							<div className="note">
								Di chuyển nội thành hoặc lân cận, lộ trình tự do.
								<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_CITY_TOUR)}>
									<IcQuestion />
								</div>
							</div>
							<div className="search-form">
								<div className="search-form__item">
									<div className="title no-space">
										<div className="wrap-svg">
											<IcLocationSearch />
										</div>

										<div className="choose-item has-arrow">
								
											<SearchSuggest
												focusAddress={true}
												getDeliveryAirportWDId={this.getDeliveryAirportWDId}
												inputProps={{
													value: addressArray[0],
													onChange: (address) => this.onAddressChangewd(address, 0),
													placeholder: "Tôi muốn đón tại...",
												}}
												onSelect={(address) => this.onSelectAddresswd(address, 0)}
											/>
										</div>
									</div>
								</div>
							</div>
						</>
					) :  wdOneWay ? (
						<>
							
								<div className="note">
									Di chuyển liên tỉnh, trả khách tại điểm đến.
									<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_ONEWAY)}>
										<IcQuestion />
									</div>
								</div>
						
							{addressArray.map((address, index) => (
								<div className="search-form" key={index}>
									<div className="search-form__item">
										<div className="title">
											<div className="wrap-svg">{index === 0 ? <IcStartLocWD /> : <IcEndLocWD />}</div>
											{index === 0 ? <p>Điểm đón</p> : <p>Điểm đến</p>}
										</div>
										<div className="choose">
											<div className={`choose-item ${index === 0 || index === 1 ? "" : "has-remove"}`}>
												<SearchSuggest
													focusAddress={true}
													inputProps={{
														value: address,
														onChange: (address) => this.onAddressChangewd(address, index),
														placeholder: address,
													}}
													onSelect={(address) => this.onSelectAddresswd(address, index)}
												/>
												{!(index === 0 || index === 1) && (
													<div className="wrap-svg" onClick={() => this.onRemoveStopPoint(index)}>
														<IcCloseOrange />
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							))}
							{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
								<div className="search-form" onClick={this.onAddStopPoint}>
									<div className="search-form__item">
										<div className="title add">
											<div className="wrap-svg">
												<IcPlusCGreen />
											</div>
											<p>Thêm điểm đến</p>
										</div>
									</div>
								</div>
							)}

						</>
					) : (	<>
							<div className="note">
								Di chuyển liên tỉnh, trả khách về lại điểm đón.
								<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_TWOWAY)}>
									<IcQuestion />
								</div>
							</div>
							{addressArray.map((address, index) => (
								<div className="search-form" key={index}>
									<div className="search-form__item">
										<div className="title">
											<div className="wrap-svg">{index === 0 ? <IcStartLocWD /> : <IcEndLocWD />}</div>
											{index === 0 ? <p>Điểm đón</p> : <p>Điểm đến</p>}
										</div>
										<div className="choose">
											<div className={`choose-item ${index === 0 || index === 1 ? "" : "has-remove"}`}>
												<SearchSuggest
													focusAddress={true}
													inputProps={{
														value: address,
														onChange: (address) => this.onAddressChangewd(address, index),
														placeholder: address,
													}}
													onSelect={(address) => this.onSelectAddresswd(address, index)}
												/>
												{!(index === 0 || index === 1) && (
													<div className="wrap-svg" onClick={() => this.onRemoveStopPoint(index)}>
														<IcCloseOrange />
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							))}
							{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
								<div className="search-form" onClick={this.onAddStopPoint}>
									<div className="search-form__item">
										<div className="title add">
											<div className="wrap-svg">
												<IcPlusCGreen />
											</div>
											<p>Thêm điểm đến</p>
										</div>
									</div>
								</div>
							)}


							</>
					)}
					<h6 className="title-wd">Thời gian</h6>
					<div className="search-form wd">
						<div className="search-form__item" onClick={this.openWDCalendar}>
							<div className="title no-space">
								<div className="wrap-svg">
									<IcCalendarSearch />
								</div>
								<label className="choose-item has-arrow">
									<span className="value">
										{formatTime(startTimewd)}, {startDatewd ? startDatewd.format("DD/MM/YYYY") : "Chọn ngày"} -{" "}
										{formatTime(endTimewd)}, {endDatewd ? endDatewd.format("DD/MM/YYYY") : "Chọn ngày"}
									</span>
								</label>
							</div>

							{/* <label className="choose-item has-arrow">
									<span className="value">{startDatewd ? startDatewd.format("HH:mm") : "Chọn giờ"}</span>
								</label> */}
						</div>

						<a className="btn btn-primary" target={`${isIframe ? "_blank" : ""}`} onClick={this.findCarwd}>
							Tìm Xe
						</a>
					
						{/* <Link
							className="btn btn-primary"
							target={`${isIframe ? "_blank" : ""}`}
							onClick={this.findCarwd}
							to={{
								pathname: `/withdriver/find/filter`,
								search: `startDate=${startDatewd.valueOf()}&endDate=${endDatewd.valueOf()}&address=${
									addressArray.includes("") ? addressArray[0] : addressArray.join(";")
								}&isCityTourMode=${isCityTourMode}&isOneWay=${wdOneWay}&selectHour=${selectHour}${
									deliveryAirportWDId !== 0 ? `&deliveryId=${deliveryAirportWDId}&isAirDelivery=true` : ""
								}`,
							}}>
							Tìm Xe
						</Link> */}
			
					</div>
					{isDateBox && (
						<DateBoxWD
							startDate={startDatewd}
							endDate={endDatewd}
							startTime={startTimewd}
							endTime={endTimewd}
							finding={false}
							onStartTimeChange={this.onStartTimeChangewd}
							onEndTimeChange={this.onEndTimeChangewd}
							onStartDateChange={this.onStartDateChangewd}
							onDatesChange={this.onDateRangeChangewd}
							show={isDateBox}
							isMCalendar={this.state.isMCalendar}
							hideModal={this.closeWDCalendar}
							wrapperSelect={this.wrapperSelect}
							toggleDurationTimeBox={this.toggleDurationTimeBox}
							onSelectHourChange={this.onSelectHourChange}
							selectHour={selectHour}
							durationTimeArr={durationTimeArr}
							isSelectHour={isSelectHour}
							wdMinHourDetected={wdMinHourDetected}
						/>
					)}
					{wdMinHourDetected && (
						<div className="search-form wd">
							{wdDistance > 4000 ? (
								<p className="text-danger font-13 marginBottom-xs">Không hỗ trợ lộ trình chuyến đi</p>
							) : (
								wdMinHourDetected && (
									<p className="text-danger font-13 marginBottom-xs">
										Thời gian thuê tối thiểu cho lộ trình trên là {wdMinHourDetected} tiếng.
									</p>
								)
							)}
						</div>
					)}
					<MessageBox show={errMsg !== ""} hideModal={this.hideMessageBox} message={errMsg} />
					<WdTypeInfoBox
						show={this.state.isShowWdTypeInfoBox}
						hideModal={this.hideWdTypeInfoBox}
						wdType={this.state.wdType}
					/>
				</>
		} else {
			content = (
				
					<div className="search-form cs">
					<div className="search-form__item address">
						<div className="title">
							<div className="wrap-svg">
								<IcLocationSearch />
							</div>
							<p>Địa điểm áp dụng hiện tại</p>
						</div>
						<div className="choose">
							<div className="choose-item pointer-none">
								<p className="address">{addressCS}</p>
							</div>
						</div>
					</div>
					{/* <div className="line" />
					<TimeSelect 
						startDate={startDatecs} 
						endDate={endDatecs} 
						timeCS={timeCS} 
						isSelectTimeCS={isSelectTimeCS}
						wrapperCSSelect={this.wrapperCSSelect}
						toggleSelectTimeCS={this.toggleSelectTimeCS}
						onSelectTimeCSChange={this.onSelectTimeCSChange}  /> */}
					<Link
						to={{
							pathname: `/carsubscription/find/filter`,
							search: `startDate=${startDatecs.valueOf()}&endDate=${endDatecs.valueOf()}&timeCS=${timeCS}&address=${addressCS}&loc=${locCS}${
								deliveryAirportId !== 0 ? `&deliveryId=${deliveryAirportId}&isAirDelivery=true` : ""
							}`,
						}}
						className="btn btn-primary">
						Tìm Xe
					</Link>
					{isOptionalTime && <OptionalTime show={isOptionalTime} onHide={this.hideOptionalTime} />}
				</div>
		
			
			);
		}

		return (
			<div className={`banner-section  ${city ? "city" : ""}`}>
				<div className="m-container">
					<div
						className="background space sec"
						style={{ backgroundImage: `url(${city ? city.cover : bgRandom.imgBg})` }}>
						{city ? (
							<h1>
								{stype === stypes.SD ? "Thuê xe tự lái tại" : "Thuê xe du lịch tại"} &nbsp;{this.props.city.name}
							</h1>
						) : (
							<>
								<h1>Mioto&nbsp;-&nbsp;Cùng&nbsp;Bạn Đến Mọi Hành&nbsp;Trình</h1>
								{/* <NumberSection /> */}
								<div className="line-bg" />
								<h6 className="text-white">
									Trải nghiệm sự khác biệt từ <span className="text-primary">hơn 8000</span> xe gia&nbsp;đình
									đời&nbsp;mới khắp Việt&nbsp;Nam
								</h6>
							</>
						)}
					</div>
					<div className="search-option">
						{!city ? (
							<div className="option">
								<div
									className={`option-item ${stype === stypes.SD ? "active" : ""}`}
									onClick={() => this.setSTypes(stypes.SD)}>
									<div className="wrap-svg">
										<IcCarSD />
									</div>
									<p>Xe tự lái</p>
								</div>
								<div
									className={`option-item ${stype === stypes.WD ? "active" : ""}`}
									onClick={() => this.setSTypes(stypes.WD)}>
									<div className="wrap-svg">
										<IcWD />
									</div>
									<p>Xe có tài xế</p>
								</div>
								<div
									className={`option-item ${stype === stypes.CS ? "active" : ""}`}
									onClick={() => this.setSTypes(stypes.CS)}>
									
									<div className="wrap-svg">
										<IcCS />
									</div>
									<p>Thuê xe dài hạn</p>
									<span className="tag-new font-12">Mới</span>
								</div>
							</div>
						) : null}
						<div className="search">
							{/* <div className="holiday-item">
								<img src={holiday} />
							</div> */}
							
							{content} 
							
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapState(state) {
	return {
		appInit: state.appInit,
		carFinding: state.carFinding,
	};
}

Cover = connect(mapState)(Cover);

export default Cover;


	{/* <div className="search-form__item">
							<div className="title">
								<div className="wrap-svg">
									<IcCalendarSearch />
								</div>
								<p>Kết thúc</p>
							</div>
							<div className="choose">
								<label className="choose-item has-arrow">
									<span className="value">{endDatewd ? endDatewd.format("DD/MM/YYYY") : "Chọn ngày"}</span>
								</label>

								<label className="choose-item has-arrow">
									<span className="value">{endDatewd ? endDatewd.format("HH:mm") : "Chọn giờ"}</span>
								</label>
							</div>
						</div> */}

						{/* 
						<DateRangePicker
							initialSettings={{
								startDate: startDatewd,
								endDate: endDatewd,
								minDate: moment(minDate),
								maxDate: moment(maxDate),
								timePicker: true,
								timePicker24Hour: true,
								timePickerIncrement: 30,
								singleDatePicker: true,

								isIOs: isIOS,
								template: WDCalendarTemplate,
								buttonClasses: ["btn btn--m btn-primary"],
								locale: {
									applyLabel: "Áp dụng",
								},
								opens: "center",

								linkedCalendars: true,
								singelSelect: true,
							}}
							onHide={this.onStartDateChangewd}>
							<div className="search-form__item">
								<div className="title">
									<div className="wrap-svg">
										<IcCalendarSearch />
									</div>
									<p>Bắt đầu</p>
								</div>
								<div className="choose">
									<label className="choose-item has-arrow">
										<span className="value">{startDatewd ? startDatewd.format("DD/MM/YYYY") : "Chọn ngày"}</span>
									</label>

									<label className="choose-item has-arrow">
										<span className="value">{startDatewd ? startDatewd.format("HH:mm") : "Chọn giờ"}</span>
									</label>
								</div>
							</div>
						</DateRangePicker> */}

						{/* <div className="line"></div> */}

						{/* <div className="search-form__item">
							<div className="title">
								<div className="wrap-svg">
									<IcTime />
								</div>
								<p>Thời gian thuê</p>
							</div>

						

							<div className="choose" ref={this.wrapperSelect}>
								<div className="choose-item has-arrow">
									{selectHour > 0 ? (
										<p className="select" onClick={this.toggleDurationTimeBox}>
											{convertToHourText(selectHour)}{" "}
											<span className="note-time">
												(kết thúc {getEndDatewd(selectHour, startDatewd).format("HH:mm DD/MM/YYYY")})
											</span>
										</p>
									) : (
										<p className="select" onClick={this.toggleDurationTimeBox}>
											Tùy chỉnh
										</p>
									)}

									{isSelectHour && (
										<div className="options">
											{durationTimeArr &&
												durationTimeArr.map((time) => (
													<div className="custom-radio" key={time}>
														<input
															type="radio"
															id={`selectHour_${time}`}
															name="selectHour"
															checked={selectHour === time}
															value={time}
															onChange={this.onSelectHourChange}
														/>
														{time > 0 ? (
															<label htmlFor={`selectHour_${time}`}>
																{convertToHourText(time)}
																<span className="note-time">
																	(kết thúc {getEndDatewd(time, startDatewd).format("HH:mm DD/MM/YYYY")})
																</span>
															</label>
														) : (
															<label htmlFor={`selectHour_${time}`}>Tùy chỉnh</label>
														)}
													</div>
												))}
										</div>
									)}
								</div>
							</div>
						</div> */}

						{/* {selectHour === 0 && <div className="line"></div>} */}
						{/* {selectHour === 0 && (
							<DateRangePicker
								initialSettings={{
									startDate: endDatewd,
									endDate: endDatewd,
									minDate: moment(minDate),
									maxDate: moment(maxDate),
									timePicker: true,
									timePicker24Hour: true,
									timePickerIncrement: 30,
									singleDatePicker: true,

									isIOs: isIOS,
									template: WDECalendarTemplate,
									buttonClasses: ["btn btn--m btn-primary"],
									locale: {
										applyLabel: "Áp dụng",
									},
									opens: "center",
									linkedCalendars: true,
									singelSelect: true,
								}}
								onHide={this.onDateRangeChangewd}>
								<div className="search-form__item">
									<div className="title">
										<div className="wrap-svg">
											<IcCalendarSearch />
										</div>
										<p>Kết thúc</p>
									</div>
									<div className="choose">
										<label className="choose-item has-arrow">
											<span className="value">{endDatewd ? endDatewd.format("DD/MM/YYYY") : "Chọn ngày"}</span>
										</label>

										<label className="choose-item has-arrow">
											<span className="value">{endDatewd ? endDatewd.format("HH:mm") : "Chọn giờ"}</span>
										</label>
									</div>
								</div>
							</DateRangePicker>
						)} */}
	{/* <DateRangePicker
						initialSettings={{
							startDate: startDate ? startDate : moment(),
							endDate: endDate ? endDate : moment().add(1, "days"),
							minDate: moment(),
						
							timePicker: true,
							timePicker24Hour: true,
							timePickerIncrement: 30,
							singleDateRangePicker: false,
							isIOs: isIOS,
							template: this.calendarTemplate(),
							buttonClasses: ["btn btn--m btn-primary"],
							locale: {
								applyLabel: "Áp dụng",
							},
							opens: "center",
							parentEl: "#home-box",
							linkedCalendars: true,
							singelSelect: true,
						}}
						onHide={this.onDateRangeChange}>
						<div className="calendar-wrap">
							<div className="search-form__item">
								<div className="title">
									<div className="wrap-svg">
										<IcCalendarSearch />
									</div>
									<p>Bắt đầu</p>
								</div>
								<div className="choose">
									<label className="choose-item has-arrow date">
										<span className="value">
											{startDate ? startDate.format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")}
										</span>
									</label>
									
									<label className="choose-item has-arrow">
										<span className="value">{startDate ? startDate.format("HH:mm") : ""}</span>
									</label>
								</div>
							</div>

							<div className="line line-time"> </div>
							<div className="search-form__item">
								<div className="title">
									<div className="wrap-svg">
										<IcCalendarSearch />
									</div>
									<p>Kết thúc</p>
								</div>
								<div className="choose">
									<label className="choose-item has-arrow date">
										<span className="value">
											{endDate ? endDate.format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")}
										</span>
									</label>
								
									<label className="choose-item has-arrow">
										<span className="value">{endDate ? endDate.format("HH:mm") : ""}</span>
									</label>
								</div>
							</div>
						</div>
					</DateRangePicker> */}
